import { Card } from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";

const AddProduct = () => {
  return (
    <div className="space-y-6">
      <div className="flex justify-between items-center">
        <h1 className="text-2xl md:text-3xl font-bold">Add New Product</h1>
      </div>
      
      <Card className="p-4 md:p-6">
        <form className="space-y-6">
          <div className="grid gap-4">
            <div className="grid gap-2">
              <Label htmlFor="name">Product Name</Label>
              <Input id="name" placeholder="Enter product name" />
            </div>
            
            <div className="grid gap-2">
              <Label htmlFor="description">Description</Label>
              <Textarea id="description" placeholder="Enter product description" />
            </div>
            
            <div className="grid md:grid-cols-2 gap-4">
              <div className="grid gap-2">
                <Label htmlFor="price">Price</Label>
                <Input id="price" type="number" placeholder="Enter price" />
              </div>
              
              <div className="grid gap-2">
                <Label htmlFor="stock">Stock</Label>
                <Input id="stock" type="number" placeholder="Enter stock quantity" />
              </div>
            </div>
            
            <div className="grid gap-2">
              <Label htmlFor="category">Category</Label>
              <Input id="category" placeholder="Enter product category" />
            </div>
            
            <div className="grid gap-2">
              <Label htmlFor="image">Product Image</Label>
              <Input id="image" type="file" />
            </div>
          </div>
          
          <div className="flex justify-end gap-4">
            <Button variant="outline">Cancel</Button>
            <Button>Add Product</Button>
          </div>
        </form>
      </Card>
    </div>
  );
};

export default AddProduct;